<!-- prettier-ignore -->

<div class="chat-header-container">

    <div class="chat-header-container__title">
        <div class="chat-header-container__title__logo-container">
            <img [src]="logoSrc() || '/assets/imgs/chatbot-avatar.png'" [alt]="chatName() || 'Cicerone'" style="object-fit: contain;">
        </div>
        <span>{{chatName() || 'Cicerone'}}</span>
    </div>

    <!-- CMAD-207 (a11y): every header control is a real <button> — keyboard reachable
         (tab) and operable (enter/space), announced as "button" with its accessible
         name (aria-label) by screen readers. WCAG 2.1.1 / 4.1.2. -->
    <div class="chat-header-container__buttons">
        @if (showRouteCta()) {
            <button type="button" class="chat-header-container__buttons__control"
                (click)="requestRoute()"
                [attr.title]="'Hacer una ruta' | translate"
                [attr.aria-label]="'Hacer una ruta' | translate">
                <icon-route aria-hidden="true" />
            </button>
        }
        <button type="button" class="chat-header-container__buttons__control"
            (click)="resetChat()"
            [attr.title]="'Reiniciar conversación' | translate"
            [attr.aria-label]="'Reiniciar conversación' | translate">
            <icon-reload aria-hidden="true" />
        </button>

        @if (isEmbed()) {
            <!-- Our style: window controls stacked vertically — maximize/restore (always
                 visible) on top, minimize below. -->
            <!-- <div class="chat-header-container__buttons__stacked-control"> -->
                @if (showMaximizeMinimizeButton()) {
                    @if (!isTrueFull()) {
                        <button type="button"
                            class="chat-header-container__buttons__control chat-header-container__buttons__control--screen-toggle"
                            (click)="toggleTrueFull()"
                            [attr.title]="'Pantalla completa' | translate"
                            [attr.aria-label]="'Pantalla completa' | translate">
                            <icon-full-screen aria-hidden="true" />
                        </button>
                    } @else {
                        <button type="button"
                            class="chat-header-container__buttons__control chat-header-container__buttons__control--screen-toggle"
                            (click)="toggleTrueFull()"
                            [attr.title]="'Salir de pantalla completa' | translate"
                            [attr.aria-label]="'Salir de pantalla completa' | translate">
                            <icon-normal-screen aria-hidden="true" />
                        </button>
                    }
                }
                <button type="button" class="chat-header-container__buttons__control"
                    (click)="minimizeToBubble()"
                    [attr.title]="'Minimizar' | translate"
                    [attr.aria-label]="'Minimizar' | translate">
                    <icon-minimize aria-hidden="true" />
                </button>
            <!-- </div> -->
        } @else {
            @if(!isFullScreen()){
                <button type="button"
                    class="chat-header-container__buttons__control chat-header-container__buttons__control--screen-toggle"
                    (click)="toggleFullScreen()"
                    [attr.title]="'Pantalla completa' | translate"
                    [attr.aria-label]="'Pantalla completa' | translate">
                    <icon-full-screen aria-hidden="true" />
                </button>
            }
            @else {
                <button type="button"
                    class="chat-header-container__buttons__control chat-header-container__buttons__control--screen-toggle"
                    (click)="toggleFullScreen()"
                    [attr.title]="'Salir de pantalla completa' | translate"
                    [attr.aria-label]="'Salir de pantalla completa' | translate">
                    <icon-normal-screen aria-hidden="true" />
                </button>
            }
            @if(showMinimize()){
                <button type="button" class="chat-header-container__buttons__control"
                    (click)="toggleView()"
                    [attr.title]="'Minimizar' | translate"
                    [attr.aria-label]="'Minimizar' | translate">
                    <icon-minimize aria-hidden="true" />
                </button>
            }
        }
    </div>

    <div class="opacityEffect opacityEffectStart"></div>

</div>
